import React from 'react';
import PropTypes from 'prop-types';

const NewPrevArrow = (props) => {
    const { className, style, onClick } = props;

    return (
        <button type="button" className={className} style={style} onClick={onClick}>
            <i className="icon-left_arrow" />
        </button>
    );
};

NewPrevArrow.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    style: PropTypes.object
};

export default NewPrevArrow;
